/**
 * Krok D2 — SLOVO „PROVĚŘENO" MA JEDINE PRAVIDLO.
 *
 * Kanonicke pravidlo je `reviewedState` v `@reos/duediligence`
 * (`public/evidence-axes.ts`). Tady je LOKALNI KOPIE ze stejneho duvodu jako
 * u `gate-catalog.ts`: web-admin smi z `@reos/duediligence` importovat jen
 * TYPY, protoze jeho jediny vstupni bod re-exportuje i server-only kod a
 * runtime import rozbije prohlizecovy build (hlida `browser-safe-imports.spec.ts`).
 * Shodu obou kopii meri `reviewed-state.spec.ts` nad spolecnou tabulkou vstupu.
 *
 * NALEZ, KTERY TOHLE RESI (GPT audit 7. 10. 2026, Q1): pruh aktualnosti rikal
 * „Prověřeno 1. 9. 2026" u zakazky, kde nebyla uzavrena JEDINA povinna oblast.
 * Datum behu rika, KDY jsme se ptali — ne, ze je na co se odkazat.
 */

import type { DecisionReadiness, ReviewedState } from '@reos/duediligence';

export type { ReviewedState };

/**
 * Proverena je zakazka, u ktere jsou VSECHNY povinne oblasti overene.
 * Prazdny seznam povinnych bran NENI „provereno" — je to „nevime nic".
 */
export function reviewedState(
  readiness: DecisionReadiness,
  options: {
    readonly missing?: readonly string[];
    readonly checkedBy?: string | null;
    readonly checkedAt?: string | null;
  } = {},
): ReviewedState {
  const total = readiness.mandatoryGatesTotal;
  const done = Math.min(readiness.mandatoryGatesClosed, total);
  const reviewed = total > 0 && readiness.state === 'DECISION_READY' && done === total;
  const missing = reviewed ? [] : [...(options.missing ?? [])];
  return {
    reviewed,
    missing,
    coverage: {
      done,
      total,
      pending: missing,
      checkedBy: options.checkedBy ?? null,
      checkedAt: options.checkedAt ?? null,
    },
  };
}
